import React, {useContext} from "react";
import {Fade} from "react-reveal";
import "./EducationCard.scss";
import StyleContext from "../../contexts/StyleContext";

export default function EducationCard({school, index}) {
  const {isDark} = useContext(StyleContext);

  return (
    <Fade bottom duration={850} distance="24px">
      <article className={`education-card ${isDark ? "education-card-dark" : ""}`}>
        <div className="education-orbit-node">
          <span>{String(index + 1).padStart(2, "0")}</span>
        </div>
        <div className="education-logo-frame">
          <span className="logo-orbit" />
          <img src={school.logo} alt={school.schoolName} />
        </div>
        <div className="education-card-copy">
          <div className="education-meta">
            <span>ACADEMIC MISSION</span>
            <time>{school.duration}</time>
          </div>
          <h2>{school.schoolName}</h2>
          <h3>{school.subHeader}</h3>
          <p className="education-label">{school.desc}</p>
          {school.descBullets && (
            <ul>
              {school.descBullets.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </article>
    </Fade>
  );
}
